/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Review_Status_Not_SubmittableInputs */

const es_co2_error_review_status_not_submittable = /** @type {(inputs: Error_Review_Status_Not_SubmittableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este formulario no está listo para enviarse a revisión.`)
};

/**

* @param {Error_Review_Status_Not_SubmittableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_review_status_not_submittable = /** @type {((inputs?: Error_Review_Status_Not_SubmittableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Review_Status_Not_SubmittableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_review_status_not_submittable(inputs)
});